import { IdValue } from '../../shared/models';
import { BorrowerAddressOwnershipTypes } from './borrower-address-types.enum';

export class AddressModel {
  addressId: number;
  addressType: BorrowerAddressOwnershipTypes = 'NotAssigned';
  city: string;
  /**
   * countryCode should truly be countryCode. However Byte treats this as country name.
   */
  countryCode = 'US';
  county: string;
  createdBy: string;
  isDeleted: boolean;
  modifiedBy: string;
  modifiedDate: string;
  monthlyRent?: number;
  months?: number;
  partyRoleIdentifier: string;
  sameAsPresentAddress?: boolean;
  state: string;
  street: string;
  years?: number;
  zipCode: string;
  isCurrent: boolean;
  unitNumber: string;
}

export const selectYesNoOptions = [new IdValue(0, null, 'Select'), new IdValue(1, true, 'Yes'), new IdValue(2, false, 'No')];
